<template>
  <a-pagination
    v-model="current"
    :showTotal="total => `共 ${total} 条`"
    showQuickJumper
    showSizeChanger
    :total="total"
    @change="change"
    @showSizeChange="showSizeChange"
  ></a-pagination>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number
    }
  },
  data() {
    return {
      current: 1,
      pageSize: 10
    };
  },
  // watch: {
  //   total(val) {
  //     if (val < this.current * this.pageSize && this.current > 1) {
  //       this.current = 1;
  //       this.$emit("change", {
  //         current: 1,
  //         pageSize: this.pageSize
  //       });
  //     }
  //   }
  // },
  methods: {
    async change(page, pageSize) {
      await this.$nextTick();
      this.$emit("change", {
        current: page,
        pageSize: pageSize
      });
    },
    async showSizeChange(current, size) {
      this.current = 1;
      this.$nextTick().then(() => {
        this.$emit("change", {
          current: this.current,
          pageSize: size
        });
      });
    }
  }
};
</script>